import { render, staticRenderFns } from "./HeaderBar.vue?vue&type=template&id=b9b79074&scoped=true"
import script from "./HeaderBar.vue?vue&type=script&lang=ts"
export * from "./HeaderBar.vue?vue&type=script&lang=ts"
import style0 from "./HeaderBar.vue?vue&type=style&index=0&id=b9b79074&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9b79074",
  null
  
)

export default component.exports